import { gql } from "@apollo/client"

const GET_ORDER_PRODUCTS_BY_ID = gql`
  query GetProductOrdersById($getProductOrdersById: ID!) {
    GetProductOrdersById(id: $getProductOrdersById) {
      order_id
      notes
      service_point_id
      shipping {
        name
        email
        address
        city
        country
        house_number
        postal_code
        telephone
      }
      items {
        _id
        product_id
        variation_id
        status
        currency
        quantity
        price
        total
        deliveryPartner
        service_point_id
        preferred_shipping_method
        item {
          product_id
          name
          sku
          stock_quantity
          estimate
          packages
          packages_dimensions {
            length
            width
            height
            weight
          }
        }
      }
      shipments {
        _id
        shipment_id
        delivery_partner
        label_status
        csv_status
        product_id {
          _id
          item {
            product_id
            name
            sku
            stock_quantity
            estimate
          }
          product_id
          status
          currency
          quantity
          price
          total
        }
      }
      dropships {
        _id
        order_id
        line_item_id
        destination
        name
        sku
      }
    }
  }
`
const GET_ALL_ORDERS = gql`
  query GetAllOrders(
    $page: Int!
    $perPage: Int!
    $search: String
    $filter: String
  ) {
    GetAllOrders(
      page: $page
      perPage: $perPage
      search: $search
      filter: $filter
    ) {
      totalCount
      orders {
        currency
        order_id
        status
        total
        shipping {
          country
        }
      }
    }
  }
`
export { GET_ORDER_PRODUCTS_BY_ID, GET_ALL_ORDERS }
